module.exports = {
  DEFAULT_TIMEZONE: 'America/Recife',
  DEFAULT_LOCALE: 'pt-br',
  MIN: 'minute',
  MS: 'millisecond',
  SECONDS_A_MINUTE: 60,
  MILLISECONDS_A_SECOND: 1e3,
  MILLISECONDS_A_MINUTE: 60 * 1e3,
  ISO8601_REGEX:
    /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/
};
